import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import {
    makeStyles,
    ListItem,
    ListItemIcon,
    ListItemText
} from '@material-ui/core';
import Icon from '@mdi/react';

import { RouteListItem } from '../../interfaces/authorizationInterfaces';

const useStyles = makeStyles((theme) => {
    return {
        listItem: {
            color: theme.palette.text.primary,
            '&:hover': {
                backgroundColor: theme.appColors.appMenuHoverBackgroundColor
            },
            '&$listItemDisabled': {
                opacity: 1
            },
            '&$listItemSelected': {
                color: theme.palette.common.white,
                backgroundColor: theme.appColors.appMenuSelectedBackgroundColor,
                '&:hover': {
                    backgroundColor: theme.appColors.appMenuSelectedBackgroundHoverColor
                }
            }
        },
        listItemDisabled: {},
        listItemSelected: {},
        listItemIcon: {
            paddingLeft: '24px'
        },
        menuTextPrimary: {
            fontSize: '16px',
            textTransform: 'none',
            fontWeight: 400
        },
        nested: {
            paddingLeft: theme.spacing(4)
        }
    };
});

const AppHeaderMenuItem = ({
    menuItem,
    isNested,
    isDisabled,
    updateIsMenuOpen
}: {
    menuItem: RouteListItem;
    isNested: boolean;
    isDisabled: boolean;
    updateIsMenuOpen: Function;
}): JSX.Element => {
    const classes = useStyles();
    const history = useHistory();
    const location = useLocation();

    const isItemSelected = (): boolean => {
        // first check to make sure there is a menuPath on the menuItem
        if (menuItem.menuPath) {
            // then if there are subRoutes, don't show this item as selected
            if (menuItem.subRoutes && menuItem.subRoutes.length > 0) {
                return false;
            }

            // if no subRoutes, determine if the menuItem is selected based on the location url
            return location.pathname.startsWith(menuItem.menuPath);
        }

        return false;
    };

    return (
        <ListItem
            button
            selected={isItemSelected()}
            onClick={(): void => {
                updateIsMenuOpen(false);
                history.push(menuItem.path);
            }}
            disabled={isDisabled}
            classes={{
                root: classes.listItem,
                selected: classes.listItemSelected,
                disabled: classes.listItemDisabled
            }}
            className={isNested === true ? classes.nested : ''}
        >
            {
                menuItem.menuIcon &&
                <ListItemIcon className={classes.listItemIcon}>
                    <Icon
                        path={menuItem.menuIcon}
                        title={menuItem.menuTitle || 'menu icon'}
                        size={1}
                    />
                </ListItemIcon>
            }
            {
                menuItem.menuTitle &&
                <ListItemText
                    primary={menuItem.menuTitle}
                    classes={{ primary: classes.menuTextPrimary }}
                />
            }
        </ListItem>
    );
};

export default AppHeaderMenuItem;
